<template>
  <div>
    <b-row class="align-items-center justify-content-between g-0">
      <b-container class="user-about mt-4">
        <b-form @submit.prevent="handleSubmit" @reset.prevent="handleReset" id="profileForm" class="bg-white">
          <h4 class="text-info text-center font-weight-bolder mb-4">Edit General Details</h4>
           <!-- Sticky Save & Cancel Buttons -->
           <b-form-group class="text-center sticky-top bg-white py-2">
            <b-button type="submit" variant="success" size="sm" :disabled="isSubmitting">
              {{ isSubmitting ? 'Please Wait...' : 'Save' }}
            </b-button>
            <b-button type="reset" variant="danger" size="sm" class="ml-2" :disabled="isSubmitting">
              Cancel
            </b-button>
          </b-form-group>
          <b-form-group label="First Name" label-for="first-name-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="first-name-input" v-model="userProfile.first_name" size="sm"
              :class="{ 'is-invalid': responseErrors.first_name }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.first_name">{{ responseErrors.first_name[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Last Name" label-for="last-name-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="last-name-input" v-model="userProfile.last_name" size="sm"
              :class="{ 'is-invalid': responseErrors.last_name }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.last_name">{{ responseErrors.last_name[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Gender" label-for="gender-input" label-cols-sm="3" label-align-sm="left" label-size="sm" class="mb-2">
            <b-form-select id="gender-input" v-model="userProfile.gender" size="sm" :options="genderOptions"
              :class="{ 'is-invalid': responseErrors.gender }"></b-form-select>
            <b-form-invalid-feedback v-if="responseErrors.gender">{{ responseErrors.gender[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <!-- <b-form-group label="Date of Birth" label-for="dob-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-datepicker id="dob-input" v-model="userProfile.birth_date" size="sm"
              :class="{ 'is-invalid': responseErrors.birth_date }" placeholder="YYYY-MM-DD"></b-form-datepicker>
            <b-form-invalid-feedback v-if="responseErrors.birth_date">{{ responseErrors.birth_date[0] }}</b-form-invalid-feedback>
          </b-form-group> -->

          <b-form-group label="Date of Birth" label-for="dob-input" label-cols-sm="3" label-align-sm="left"
              label-size="sm" class="mb-2">
            <b-form-input v-model="userProfile.birth_date" type="date"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.birth_date">{{ responseErrors.birth_date[0] }}</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Blood Group" label-for="blood-group-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-select id="blood-group-input" v-model="userProfile.blood_group" size="sm" :options="bloodGroups"
              :class="{ 'is-invalid': responseErrors.blood_group }"></b-form-select>
            <b-form-invalid-feedback v-if="responseErrors.blood_group">{{ responseErrors.blood_group[0] }}</b-form-invalid-feedback>
          </b-form-group>
  
          <b-form-group label="Category" label-for="last-name-input" label-cols-sm="3" label-align-sm="left"
            label-size="sm" class="mb-2">
            <b-form-input id="last-name-input" v-model="userProfile.category" size="sm"
              :class="{ 'is-invalid': responseErrors.category }"></b-form-input>
            <b-form-invalid-feedback v-if="responseErrors.category">{{ responseErrors.category[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </b-form>
      </b-container>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userProfile: { ...this.profile },
      genderOptions: [
        { value: null, text: 'Select Gender' },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' },
        { value: 'other', text: 'Other' },
      ],
      bloodGroups: [
        { value: null, text: 'Select Blood Group' },
        { value: 'A+', text: 'A+' },
        { value: 'A-', text: 'A-' },
        { value: 'B+', text: 'B+' },
        { value: 'B-', text: 'B-' },
        { value: 'AB+', text: 'AB+' },
        { value: 'AB-', text: 'AB-' },
        { value: 'O+', text: 'O+' },
        { value: 'O-', text: 'O-' },
      ],
      responseErrors: {},
      isSubmitting: false,
    };
  },
  methods: {
    async handleSubmit() {
      this.isSubmitting = true;
      try {
        await this.$store.dispatch('storeUserProfile', this.userProfile);
        this.$toast.success('Profile Updated', { position: 'top', duration: 3000 });
        this.$emit('profileCancelled');
        this.$emit("profileUpdated");
      } catch (error) {
        this.responseErrors = error.response.data.errors || {};
      } finally {
        this.isSubmitting = false;
      }
    },
    handleReset() {
      this.userProfile = { ...this.profile };
      this.responseErrors = {};
      this.$emit('profileCancelled');
    },
  },
};
</script>
<style scoped>
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid #ddd;
}
</style>
